import React, { useEffect, useState } from "react";
import api from "../services/api";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import { useMsal } from "@azure/msal-react";

interface ModalChangeGroupProps {
  token: string;
  onClose: () => void;
  onCloseSave: () => void;
  isModalVisible: boolean;
  candidate: any;
  group: any;
  //closeFullModal: (flag:any) => void;
}

const ModalChangeGroup: React.FC<ModalChangeGroupProps> = ({
  token,
  isModalVisible,
  onClose,
  onCloseSave,
  candidate,
  group,
}) => {
  const [positions, setPositions] = useState<any[]>([]);
  const [position, setPosition] = useState<any>("");
  const { instance } = useMsal();

  const updateIdBusqueda = () => {
    if (candidate.busquedaId != position) {
      api
        .put(`busqueda-persona-busqueda`, null, {
          params: { busPerId: candidate.busPerId, busquedaId: position },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((response: any) => {
          onCloseSave();
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      onClose();
    }
  };

  const getGroups = () => {
    api
      .get(`cargoGroup-assigned/`, {
        params: { usuarioId: instance.getActiveAccount()?.localAccountId },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        setPositions(response.data.data);
      })
      .catch((error) => {
        console.log("Error al descargar");
      });
  };

  // useEffect

  useEffect(() => {
    if (token) {
      getGroups();
    }
  }, [token]);

  useEffect(() => {
    if (candidate) {
      if (candidate) {
        setPosition(candidate.cargoGroupId);
      }
    }
  }, [candidate]);
  return (
    <div>
      <Dialog
        header={null}
        visible={isModalVisible}
        onHide={onClose}
        breakpoints={{ "960px": "75vw" }}
        style={{ width: "589px", height: "372px" }}
        closable={false}
        draggable={false}
        footer={" "}
      >
        <div className="mt-3 mb-4 mr-4 ml-5 ">
          <div className="mb-3">
            <span
              className="material-symbols-outlined"
              style={{ color: "#2A63D5" }}
            >
              published_with_changes
            </span>
            <label
              className="ml-3"
              style={{
                fontFamily: "Roboto",
                fontStyle: "",
                fontSize: "23px",
                lineHeight: "26px",
                alignItems: "center",
                fontWeight: "600",
                color: "#333333",
              }}
            >
              Cambiar candidato de grupo
            </label>
          </div>
          <div>
            <p className="text-justify">
              Movera al candidato con la información actual a otro grupo.
            </p>
            <br></br>
            {candidate ? (
              <>
                <p className="text-justify mb-5">
                  <b>
                    Por favor ingresa el cargo para {candidate.fullname} ({" "}
                    {candidate.personaDni} ){" "}
                  </b>
                </p>
              </>
            ) : (
              ""
            )}
          </div>
          {positions ? (
            <div className="flex flex-column">
              <Dropdown
                value={position}
                options={positions}
                onChange={(e) => setPosition(e.target.value)}
                optionLabel="cargoGroupName"
                optionValue="cargoGroupId"
                placeholder="Seleccione ID y Cargo"
                appendTo="self"
              />
            </div>
          ) : (
            ""
          )}
        </div>

        <div className="flex justify-content-between mt-6 mr-4 ml-5 ">
          <a
            className="cursor-pointer"
            style={{
              fontFamily: "Roboto",
              fontStyle: "",
              fontSize: "14px",
              lineHeight: "16px",
              alignItems: "center",
              fontWeight: "600",
              color: "#2A63D5",
              textDecoration: "underline",
            }}
            onClick={() => {
              onClose();
            }}
          >
            Cancelar
          </a>
          <Button
            label="Mover"
            className="p-button-sucess"
            onClick={() => updateIdBusqueda()}
            style={{ width: "180px" }}
          />
        </div>
      </Dialog>
    </div>
  );
};

export default ModalChangeGroup;
